var _changeHandlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable consistent-return */
import objectEach from 'fast-loops/lib/objectEach';
import { RULE_TYPE, KEYFRAME_TYPE, FONT_TYPE, STATIC_TYPE, CLEAR_TYPE, generateCSSRule } from 'fela-utils';

import getDOMNode from './getDOMNode';
import generateRule from './generateRule';

var changeHandlers = (_changeHandlers = {}, _defineProperty(_changeHandlers, RULE_TYPE, function (node, _ref) {
  var selector = _ref.selector,
      declaration = _ref.declaration,
      support = _ref.support;

  var cssRule = generateRule(selector, declaration, support);

  // only use insertRule in production as browser devtools might have
  // weird behavior if used together with insertRule at runtime
  if (process.env.NODE_ENV !== 'production') {
    node.textContent += cssRule;
    return;
  }

  try {
    node.sheet.insertRule(cssRule, node.sheet.cssRules.length);
  } catch (e) {
    // TODO: warning?
  }
}), _defineProperty(_changeHandlers, KEYFRAME_TYPE, function (node, _ref2) {
  var keyframe = _ref2.keyframe;

  node.textContent += keyframe;
}), _defineProperty(_changeHandlers, FONT_TYPE, function (node, _ref3) {
  var fontFace = _ref3.fontFace;

  node.textContent += fontFace;
}), _defineProperty(_changeHandlers, STATIC_TYPE, function (node, _ref4) {
  var selector = _ref4.selector,
      css = _ref4.css;

  if (selector) {
    node.textContent += generateCSSRule(selector, css);
  } else {
    node.textContent += css;
  }
}), _changeHandlers);

export default function createDOMSubscription(nodes) {
  var baseNode = nodes[RULE_TYPE];

  return function changeSubscription(change) {
    if (change.type === CLEAR_TYPE) {
      return objectEach(nodes, function (node) {
        node.textContent = '';
      });
    }

    var handleChange = changeHandlers[change.type];

    if (handleChange) {
      var node = getDOMNode(nodes, baseNode, change.type, change.media, !!change.support);

      handleChange(node, change);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/createDOMSubscription.js
// module id = 849
// module chunks = 1